function UserSubscriptionsCouponTemplates () {
  function ToggleFields () {
    function hideField (classSelector) {
      const selector = `${classSelector} :input`

      $(classSelector).addClass('hide')
      $(selector).removeAttr('required')
    }

    function showField (classSelector) {
      const selector = `${classSelector} :input`

      $(classSelector).removeClass('hide')
      $(selector).prop('required', true)
    }

    function checkTemplateTypeFields (selectedType) {
      checkUsageLimit()

      if (selectedType === 'cashback') {
        showField('.cashback_coupon_group')
      } else {
        hideField('.cashback_coupon_group')
      }

      if (selectedType === 'normal' || selectedType === 'cashback') {
        showField('.credit_type')
      } else {
        hideField('.credit_type')
        hideField('.amount')
        hideField('.percentage')
        hideField('.maximum_discount')
      }
    }

    function checkCreditTypeFields (selectedType) {
      checkUsageLimit()

      if (selectedType === 'amount') {
        showField('.amount')
        hideField('.percentage')
        hideField('.maximum_discount')
      } else if (selectedType === 'percent') {
        hideField('.amount')
        showField('.percentage')
        showField('.maximum_discount')
      } else {
        hideField('.amount')
        hideField('.percentage')
        hideField('.maximum_discount')
      }
    }

    function checkUsageLimit () {
      const templateTypeValue = $('#user_subscriptions_coupon_template_template_type').val()
      const creditTypeValue = $('#user_subscriptions_coupon_template_credit_type').val()

      if (templateTypeValue === 'normal' && creditTypeValue === 'percent') {
        showField('.usage_limit')
      } else {
        hideField('.usage_limit')
      }
    }

    function checkOnloadFields () {
      const templateTypeValue = $('#user_subscriptions_coupon_template_template_type').val()
      checkTemplateTypeFields(templateTypeValue)
      const creditTypeValue = $('#user_subscriptions_coupon_template_credit_type').val()
      checkCreditTypeFields(creditTypeValue)
    }

    $(document).on('change', '#user_subscriptions_coupon_template_template_type', function () {
      const selectedType = $(this).val()

      checkTemplateTypeFields(selectedType)
    })

    $(document).on('change', '#user_subscriptions_coupon_template_credit_type', function () {
      const selectedType = $(this).val()

      checkCreditTypeFields(selectedType)
    })

    checkOnloadFields()
  }

  if (window.location.pathname.includes('user_subscriptions/coupon_templates')) {
    ToggleFields()
  }
}

export default UserSubscriptionsCouponTemplates
